import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { getReviewRequest } from "@/lib/client/review";
import { ApplicationForm } from "@/features/user/components/application-form";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function UpdateReviewRequestDialogContent({
  id,
  open,
  onSuccess,
}: {
  id: string;
  open: boolean;
  onSuccess: () => void;
}) {
  const { data: original } = useQuery({
    queryKey: ["review-request", id],
    queryFn: () => {
      return getReviewRequest({ data: { id } });
    },
    enabled: open,
  });

  return (
    <DialogContent className="[--container-sm:36rem] p-0 overflow-hidden w-[min(95vw,40rem)] max-w-none max-h-[85vh] overflow-x-hidden">
      <div className="max-h-[85vh] w-full overflow-y-auto overflow-x-hidden px-6 py-4 min-w-0">
        <DialogHeader>
          <DialogTitle>
            <span className="align-middle">修改申请</span>
            {!original && <Loader2 className="inline animate-spin ml-2 size-4" />}
          </DialogTitle>
          <DialogDescription />
        </DialogHeader>

        {original ? (
          <div className="w-full min-w-0">
            <ApplicationForm
              initialValues={{
                ...original,
                public:
                  original.visibility === "public-requested" || original.visibility === "public",
              }}
              id={id}
              onSuccess={onSuccess}
            />
          </div>
        ) : (
          <Loader2 className="animate-spin py-12" />
        )}
      </div>
    </DialogContent>
  );
}
